<template>
    <TourEdit></TourEdit>
</template>

<script setup>

import TourEdit from '@/components/TourEdit.vue'

</script>
